export interface DebugToggle {
  name: string;
  enabled: boolean;
  type: ToggleType;
}

export enum ToggleType {
  DisplayConversionId = 'Display conversion Ids',
  DisplayOpportunityId = 'Display opportunity Ids',
  DisplayRevenueId = 'Display revenue Ids',
  DisplayPathsTimeToConversion = 'Display paths time to conversion',
  POCToggle = 'POC Toggle',
  AdvancedReports = 'Advanced Reports',
  DisplayPOCDashboardTiles = 'Display POC dashboard tiles',
  DisplayNewSideBar = 'Displays The New Side Bar'
}
